import { render } from "./HomeLabView.vue?vue&type=template&id=4ab91952&scoped=true&ts=true"
import script from "./HomeLabView.vue?vue&type=script&lang=ts"
export * from "./HomeLabView.vue?vue&type=script&lang=ts"

import "./HomeLabView.vue?vue&type=style&index=0&id=4ab91952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab91952"]])

export default __exports__